// Generated by genversion.
export const version = '5.2.2'
